import { ChevronRight } from 'lucide-react';
import methodCreditCardIcon from '@/assets/method-credit-card.svg';

interface MoreOptionsProps {
  /** When set, renders a live "Credit Card" row as the first option — used
   *  when the user has no saved card, per the redesign. */
  onCreditCard?: () => void;
  /** Locks the credit-card row (gate-disabled / pay in flight). */
  creditCardDisabled?: boolean;
}

/**
 * "More Options" payment group — tall pill buttons from the redesign. When
 * the user has no saved card, the Credit Card method lives here (via
 * `onCreditCard`) instead of in its own labeled section. Interac and Bank
 * Account aren't wired to a payment flow yet, so those are rendered as
 * coming-soon (disabled, non-interactive) to match the design while
 * signalling that they aren't live.
 */
export function MoreOptions({ onCreditCard, creditCardDisabled }: MoreOptionsProps) {
  return onCreditCard ? (
    <div className="flex flex-col gap-2">
      <span className="text-[18px] font-semibold text-ink">More Options</span>
      <div className="flex flex-col gap-2.5">
        <button
          type="button"
          disabled={creditCardDisabled}
          onClick={onCreditCard}
          className="flex h-[52px] w-full items-center gap-3 rounded-[40px] border-2 border-stroke-soft bg-surface px-4 text-left transition-all duration-150 hover:border-purple/40 hover:shadow-card disabled:pointer-events-none disabled:opacity-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple/40 focus-visible:ring-offset-2"
        >
          <img src={methodCreditCardIcon} alt="" aria-hidden="true" className="h-11 w-auto shrink-0" />
          <span className="text-[18px] font-medium text-ink">Credit Card</span>
          <ChevronRight className="ml-auto size-4 shrink-0 text-ink-muted" />
        </button>
      </div>
    </div>
  ) : null;
}
